import firebase from "../../firebase";

export default function ({ officeId, officeName }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "user",
        funcName: "changeAccessCode",
        data: { officeId }
    });
}
